import React, { Dispatch, SetStateAction, useContext, useEffect, useRef } from 'react';
import ConfirmIcon from '../../../images/icon-confirm.svg';
import CloseICon from '../../../images/icon-close.svg';
import styles from './visitorAppointment.module.css';
import { useNavigate } from 'react-router-dom';
import { AppointmentPopupInterface } from '../interface/Visitor.interface';
import { AvailabilityRedirectionContext } from '../../context/availabilityRedirection';

const AppointmentPopup = ({ message, title, setShowModalPopup }: AppointmentPopupInterface) => {
    const modalRef = useRef(null);

    const navigate = useNavigate();

    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    useEffect(() => {
        document.addEventListener('mousedown', closeModalHandler);

        return () => {
            document.removeEventListener('mousedown', closeModalHandler);
        };
    }, []);

    const closeModalHandler = () => {
        setShowModalPopup(false);
        navigate('/visitor');
        availabilityRedirectionContext?.setAvailabilityData({
            locationId: '',
            locationName: '',
            selectedDate: '',
            slotRange: '',
            unitId: '',
            unitName: '',
            lockerNumber: 0
        });
        availabilityRedirectionContext?.setData([]);
        availabilityRedirectionContext?.setLocationDetails({
            id: '',
            images: [],
            name: '',
            provisioningId: '',
            timeZone: '',
            street1: '',
            street2: '',
            streetNumber: '',
            city: '',
            state: '',
            zip: '',
            description: '',
            lockerName: ''
        });
        availabilityRedirectionContext?.setSelectedUserTableData({
            name: '',
            bedrooms: '',
            contact: '',
            date: '',
            email: '',
            countryCode: '',
            locationName: '',
            companyName: '',
        });
        availabilityRedirectionContext?.setStep(1);
        availabilityRedirectionContext?.setUserId('');
    };

    return (
        <div ref={modalRef} className={styles.modalOuter}>
            <img onClick={closeModalHandler} src={CloseICon} alt="close-icon" className={styles.closeIcon} />
            <div className={styles.modalHeader}>
                <img src={ConfirmIcon} alt="confirm icon" />
            </div>
            <div className={styles.modalBody}>
                <h2>{title}</h2>
                <p>{message} </p>
            </div>

            <div className={styles.btnContainer}>
                <button onClick={closeModalHandler} className={styles.btnGreen}>
                    Take me there
                </button>
            </div>
        </div>
    );
};

export default AppointmentPopup;
